import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/login";
import { withAlternates } from "@/lib/route-i18n";

export const Route = createFileRoute("/login")(withAlternates(routeOptions, "/login"));
